module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel05_770_280_zh-hant-df7cbf9c5122a2da662f88a10fa32574.jpg";